import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const eliminarFeriado = async ({ id, token, callbacks }) => {
    const response = await connection({ method: 'DELETE', url: `${ENTITY_URL.SUPERVISOR.FERIADOS.ELIMINAR}${id}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default eliminarFeriado;